import { Button } from "@/components/ui/button";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { useState } from "react";
import { AuthDialog } from "./AuthDialog";

export const FinalCTA = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });
  const [authDialogOpen, setAuthDialogOpen] = useState(false);
  const [authView, setAuthView] = useState<"login" | "signup">("signup");

  const openAuthDialog = (view: "login" | "signup") => {
    setAuthView(view);
    setAuthDialogOpen(true);
  };

  return (
    <>
      <section className="section-padding" ref={ref}>
        <div className="container-custom">
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={inView ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.95 }}
            transition={{ duration: 0.6 }}
            className="glass-card p-12 md:p-16 text-center bg-gradient-to-br from-purple/20 to-blue/20 hover-lift"
          >
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
              Ready to Save <span className="gradient-text">20+ Hours Per Week?</span>
            </h2>
            <p className="text-xl text-muted-foreground mb-8 max-w-3xl mx-auto">
              Join 500+ designers who automated their documentation workflow
            </p>
            <div className="flex flex-wrap gap-4 justify-center mb-6">
              <Button
                onClick={() => openAuthDialog("signup")}
                size="lg"
                className="gradient-button text-lg px-8"
              >
                Get Started Free
              </Button>
              <Button
                onClick={() => openAuthDialog("login")}
                size="lg"
                variant="outline"
                className="glass-card text-lg px-8"
              >
                Sign In
              </Button>
            </div>
            <p className="text-sm text-muted-foreground">
              No credit card required • 2 docs/month free • Cancel anytime
            </p>
          </motion.div>
        </div>
      </section>
      
      <AuthDialog 
        open={authDialogOpen} 
        onOpenChange={setAuthDialogOpen}
        defaultView={authView}
      />
    </>
  );
};
